<template>
  <span class="fa-stack">
    <slot name="icons" />
  </span>
</template>

<script>
export default {
  name: 'BaseIconStack',
}
</script>
